import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { uploadCostImpactFile } from '../../queries/fileQueries';

function UploadCostImpact(props) {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { mutate } = useMutation({
    mutationFn: uploadCostImpactFile,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cost-impact'] });
    },
    onError: error => {
      console.error('Error uploading file:', error);
    },
  });

  function handleFileChange(e) {
    const file = e.target.files[0];
    if (file) {
      mutate({
        file: file,
        pecrId: props.pecrId,
        siteId: props.siteId,
      });
    }
  }
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <input
        type="file"
        id="fileUpload"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <label htmlFor="fileUpload" className="btn">
        {t('Upload_Documents')}
      </label>
    </div>
  );
}

export default UploadCostImpact;
